import { createApp, type App } from 'vue';
import { i18n } from '../../i18n';
import DuplicatePermissionDialog from './DuplicatePermissionDialog.vue';

export const openDuplicatePermissionDialog = () => {
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(DuplicatePermissionDialog, {
            callback: () => {
                resolve(true);
                unmountApp(app);
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}
